import {assertAndContinue} from 'Asserts';
import {assertNever, JSONValue} from 'util/Types';

/**
 * @deprecated
 */
// TODO(BNCH-31259): Delete this function after completion of UB M1
// DEPRECATED. Should return '' for null values going forward.
// Use client/util/jsonValueToReadable instead.
export default function cellToString(cell: JSONValue): string {
  if (cell == null) {
    return String(cell);
  } else if (typeof cell === 'boolean' || typeof cell === 'number') {
    return cell.toString();
  } else if (typeof cell === 'string') {
    return cell;
  } else if (typeof cell === 'object') {
    // Handle both JSONObject and JSONArray
    return JSON.stringify(cell, null, 1).replace(/\s+/g, ' ');
  }
  assertAndContinue(false, `Unexpected cell type: ${assertNever(cell)}`);
  return cell;
}
